import API from "@/services/api";
import {  
  ContractationConfigResponse,
  IDNIValidationResponse,
  IScoringResponse,
  StepConfirmationFormDataAPI,
  IStepConfirmationResponseData,
  IStepSentResponse,
  StepsFormDataAPI
} from "../types/stepsAPI";
import { EndpointsLeads } from "./endpoints";

export const fetchContractationConfig = () => {
  return new Promise<ContractationConfigResponse>(async (resolve, reject) => {
    API.get<ContractationConfigResponse>({
      endpoint: EndpointsLeads.ContractationConfig,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const fetchGasContractationConfig = (cups: string) => {
  return new Promise<ContractationConfigResponse>(async (resolve, reject) => {
    API.get<ContractationConfigResponse>({
      endpoint: EndpointsLeads.GasContractationConfig,
      params: {
        cups
      },
      versions: [2]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const sendLeadStepData = (
  data: StepsFormDataAPI,
) => {
  return new Promise<IStepSentResponse>(async (resolve, reject) => {
    API.post<IStepSentResponse, StepsFormDataAPI>({
      endpoint: EndpointsLeads.Leads,
      data,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const sendGasLeadStepData = (
  data: StepsFormDataAPI
) => {
  return new Promise<IStepSentResponse>(async (resolve, reject) => {
    API.post<IStepSentResponse, StepsFormDataAPI>({
      endpoint: EndpointsLeads.GasLeads,
      data,
      versions: [2]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const confirmContractation = (
  data: StepConfirmationFormDataAPI
) => {
  return new Promise<IStepConfirmationResponseData>(async (resolve, reject) => {
    API.post<IStepConfirmationResponseData, StepConfirmationFormDataAPI>({
      endpoint: EndpointsLeads.Leads,
      data,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const confirmGasContractation = (
  data: StepConfirmationFormDataAPI
) => {
  return new Promise<IStepConfirmationResponseData>(async (resolve, reject) => {
    API.post<IStepConfirmationResponseData, StepConfirmationFormDataAPI>({
      endpoint: EndpointsLeads.GasLeads,
      data,
      versions: [2]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const fetchOfferPdf = (
  leadId: number,
  vat?: string
) => {
  return new Promise<Blob>(async (resolve, reject) => {
    const searchParams = vat ? `?vat=${encodeURIComponent('ES'+vat)}` : undefined;
    API.get<Blob>({
      endpoint: EndpointsLeads.OfferPdf,
      params: { lead_id: leadId },
      searchParams,
      versions: [1],
      config: { responseType: 'blob' }
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const fetchGasOfferPdf = (
  leadId: number,
  vat?: string
) => {
  return new Promise<Blob>(async (resolve, reject) => {
    const params: Record<string, string | number> = { lead_id: leadId };
    if (vat) {
      params.vat = vat;
    }
    API.get<Blob>({
      endpoint: EndpointsLeads.GasOfferPdf,
      params,
      versions: [2],
      config: { responseType: 'blob' }
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const checkLeadScore = (
  leadId: number
) => {
  return new Promise<IScoringResponse>(async (resolve, reject) => {
    API.get<IScoringResponse>({
      endpoint: EndpointsLeads.Scoring,
      params: {
        lead_id: leadId
      },
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const checkLeadDNI = (
  leadId: number
) => {
  return new Promise<IDNIValidationResponse>(async (resolve, reject) => {
    API.get<IDNIValidationResponse>({
      endpoint: EndpointsLeads.DNIValidation,
      params: {
        lead_id: leadId
      },
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  fetchContractationConfig,
  fetchGasContractationConfig,
  sendLeadStepData,
  sendGasLeadStepData,
  fetchOfferPdf,
  fetchGasOfferPdf,
  checkLeadScore,
  checkLeadDNI,
  confirmContractation,
  confirmGasContractation
};


